import {
  Outlet,
  Link,
  useLocation,
  NavLink,
} from 'react-router-dom';
import React, {
  Suspense, useEffect,
} from 'react';
import {
  useNavigate,
  // useSearchParams,
} from 'react-router-dom';

import styles from './Layout.module.css';

import { useAuth } from 'react-oidc-context';

import { useState } from 'react';

import { setStep, setTier, setRole } from '../../app/stepSlice';

import { motion } from 'framer-motion';

import { useDispatch, useSelector } from 'react-redux';

import MenuBar from '../../utils/MenuBar';
import SetUpRequired from './SetUpRequired';
import QuickAccessBar from '../../utils/QuickAccessBar';
import TransparentButton from '../../utils/TransparentButton';
import AccessRequired from './AccessRequired';
import DigitalWorkerLayout from '../../utils/DigitalWorkerLayout';

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: 'tween',
  ease: 'linear',
  duration: 0.15,
};

function Layout() {
  const auth = useAuth();

  const location = useLocation();

  const navigate = useNavigate();

  const [
    colorChange,
    setColorchange,
  ] = useState(false);

  const role = useSelector(state => state.step.role);

  const allSteps = useSelector(state => state.step.steps[state.step.role]);

  const dispatch = useDispatch();

  let navChangedColorHeight;

  if (location.pathname == '/') {
    navChangedColorHeight = window.innerHeight;
  } else {
    navChangedColorHeight = window.innerHeight / 2;
  }

  const changeNavbarColor = (scrollTop) => {
    if (scrollTop > 0) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };

  let scroller = document.querySelector('#scroller');
  scroller?.addEventListener('scroll', (event) => {
    changeNavbarColor(scroller.scrollTop);
  });

  return (
    <SetUpRequired>
      {/* <MenuBar /> */}

      <DigitalWorkerLayout
        tabs={[
          {
            name: 'Documents',
            routeInclude: 'reports',
            onClick: () => { navigate('/mydigitalworkers/Eva/reports'); },
          },
          {
            name: 'Clients',
            routeInclude: 'clients',
            onClick: () => { navigate('/mydigitalworkers/Eva/clients'); },
          },
        ]}
        digitalWorkerName="Eva"
        digitalWorkerDescription="ATO Communication Service for Individuals"
      />

    </SetUpRequired>
  );
}

export default Layout;
